import React from 'react';
import PropTypes from 'prop-types';

/* Molecules (baseline) */
import {Pager} from '../baseline/baseline';

/* Utils */
import translate from '../../../utils/translations';

const Pagination = ({
    handlePageChange,
    page = 1,
    pageSize,
    results,
    totalResults,
    translations = {},
}) => {
    const firstResult = (parseInt(page, 10) - 1) * pageSize + 1;
    const lastResult = results + (parseInt(page, 10) - 1) * pageSize;

    const hasNext = lastResult < totalResults;
    const hasPrev = firstResult > 1;

    const pageCount = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.pagination',
        {0: firstResult, 1: lastResult, 2: totalResults}
    );

    const handleNextClick = () => {
        handlePageChange(parseInt(page, 10) + 1);
    };

    const handlePrevClick = () => {
        handlePageChange(parseInt(page, 10) - 1);
    };

    return (
        <Pager
            className={'Pagination'}
            hasNext={hasNext}
            hasPrev={hasPrev}
            pageCount={pageCount}
            onNextClick={handleNextClick}
            onPrevClick={handlePrevClick}
        />
    );
};

Pagination.propTypes = {
    handlePageChange: PropTypes.func,
    page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pageSize: PropTypes.number,
    results: PropTypes.number,
    totalResults: PropTypes.number,
    translations: PropTypes.shape({}),
};

export default Pagination;
